import React from "react";
import { Container, Button, Carousel } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import Footer from "./Footer";
import "./home.css";
import SEO from "./SEO";
import { Helmet } from "react-helmet-async";

// Initialize Stripe with your Public Key

function Home({ t }) {
  return (
    <>
      <SEO
        title="Apprenez le Français en Ligne"
        description="Solutions Langues Québec propose des cours de français pour adultes, en ligne et sur place, ainsi que la préparation aux examens TEFAQ, TEF et TCF."
        keywords="cours de français Québec, TEFAQ Québec, TCF Canada, DELF Canada, Solutions Langues"
        canonicalUrl="https://solutionslangues.com/"
      />
      {/* JSON‑LD schema for EducationalOrganization */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            name: "Solutions Langues Québec",
            url: "https://solutionslangues.com",
            description:
              "Solutions Langues Québec propose des cours de français pour adultes de tous niveaux (A1 à C2), en ligne et en présentiel, ainsi que la préparation aux examens TEF, TCF, DELF et DALF. Centre officiel de passation TEF et DFP.",
            address: {
              "@type": "PostalAddress",
              streetAddress: "2065 Rue Frank-Carrel",
              addressLocality: "Québec",
              addressRegion: "QC",
              postalCode: "G1N 2G1",
              addressCountry: "CA",
            },
            telephone: "+1-367-382-7804",
            email: "contact@solutionslangues.com",
            areaServed: "CA-QC",
          })}
        </script>
      </Helmet>
      {/* ================= HERO ================= */}
      <section
        className="position-relative overflow-hidden d-flex align-items-center"
        style={{ height: "75vh" }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: "url('/hero.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -1,
          }}
        />

        {/* Left social bar */}
        <div
          className="d-none d-lg-flex position-absolute top-0 start-0 h-100 bg-white align-items-center"
          style={{ width: "90px" }}
        >
          {/* <div className="d-flex flex-column gap-3 mx-auto text-dark">
            <FaFacebookF />
            <FaTwitter />
            <FaLinkedinIn />
            <FaYoutube />
          </div> */}
        </div>

        {/* Right red bar */}
        <div
          className="d-none d-lg-block position-absolute top-0 end-0 h-100 bg-danger"
          style={{ width: "90px" }}
        />

        {/* Floating card */}
        <Container className="d-flex justify-content-center justify-content-lg-center align-items-end mb-2  h-100 px-3">
          <div
            className="bg-white p-3 p-lg-5 shadow-lg w-100 w-lg-auto"
            style={{ maxWidth: "880px", borderRadius: "12px" }}
          >
            <h1
              className="text-danger fw-bold d-block mb-2 fs-5 fs-md-4 fs-lg-3"
              style={{ letterSpacing: "2px" }}
            >
              {t("home.hero.title")}
            </h1>

            <p
              className="text-muted mb-3 fs-6 fs-md-5"
              style={{ textAlign: "justify" }}
            >
              {t("home.hero.description")}
            </p>

            <Button
              variant="dark"
              className="px-4 py-2 w-100 w-md-auto"
              href={t("home.hero.cta.link")}
            >
              {t("home.hero.cta.label")}
            </Button>
          </div>
        </Container>
      </section>
      {/* ================= MARQUEE ================= */}
      <section>
        <Marquee
          speed={40}
          gradient={true}
          gradientColor="white"
          gradientWidth={80}
          style={{
            background: "#ffffff",
            padding: "0",
            height: "150px",
          }}
        >
          {[
            { src: "/TEF_logotype_fond transparent.png", alt: "TEF" },
            { src: "/Logo SL rouge.png", alt: "Solutions Langues" },
            {
              src: "/Le francais des affaires-CCI_logotype_fond transparent.png",
              alt: "CCI Paris",
            },
            { src: "/Logo SL rouge.png", alt: "Solutions Langues" },
            { src: "/DFP_logotype_fond transparent.png", alt: "DFP" },
            { src: "/Logo SL rouge.png", alt: "Solutions Langues" },
          ].map((img, i) => (
            <img
              key={i}
              src={img.src}
              alt={img.alt}
              style={{
                height: "75px",
                objectFit: "contain",
                margin: "0 70px",
                opacity: 0.85,
                filter: "grayscale(20%)",
                transition: "opacity 0.3s, filter 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.filter = "grayscale(0%)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "0.85";
                e.currentTarget.style.filter = "grayscale(20%)";
              }}
            />
          ))}
        </Marquee>
      </section>

      {/* ================= STATS ================= */}
      {/* <section
        style={{
          background: "#ffffff",
          padding: "4rem 0",
          position: "relative",
          overflow: "hidden",
          height: "75vh",
        }}
      >

        <Container>
          

          <div className="row g-3 g-lg-4 justify-content-center">
            {[
              {
                value: "1 200+",
                label: t("home.stats.label"),
                icon: (
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                ),
              },
              {
                value: "5",
                label:
                  "Examens officiels TEF, TEFAQ, TEF IRN, TEF Études et DFP",
                icon: (
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                    <path d="M6 12v5c3 3 9 3 12 0v-5" />
                  </svg>
                ),
              },
              {
                value: "A1 – C2",
                label:
                  "Tous les niveaux du CECRL couverts, du débutant au maître",
                icon: (
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                  </svg>
                ),
              },
              {
                value: "100%",
                label: "Cours certifiés par la CCI Paris Île-de-France",
                icon: (
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="8" r="6" />
                    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
                  </svg>
                ),
              },
            ].map((stat, i) => (
              <div className="col-6 col-lg-3" key={i}>
                <div
                  style={{
                    background: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "16px",
                    padding: "1.8rem 1.2rem",
                    textAlign: "center",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                    transition: "transform 0.25s, box-shadow 0.25s",
                    cursor: "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 24px rgba(220,53,69,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 12px rgba(0,0,0,0.05)";
                  }}
                >
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: "50%",
                      background: "#fde8ea",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 1rem",
                      color: "#dc3545",
                    }}
                  >
                    {stat.icon}
                  </div>

                  <div
                    style={{
                      fontSize: "2rem",
                      fontWeight: 800,
                      color: "#1a1a2e",
                      lineHeight: 1,
                      marginBottom: "0.5rem",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {stat.value}
                  </div>

                  <div
                    style={{
                      width: 32,
                      height: 2,
                      background: "#dc3545",
                      margin: "0.6rem auto",
                      borderRadius: 2,
                    }}
                  />

                  <p
                    style={{
                      fontSize: "0.78rem",
                      color: "#6c757d",
                      margin: 0,
                      lineHeight: 1.5,
                    }}
                  >
                    {stat.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section> */}

      {/* ================= WHY CHOOSE US ================= */}
      <section className="bg-white py-5">
        <Container>
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-5 text-center text-lg-start">
            <div style={{ maxWidth: "520px" }}>
              <small className="text-danger fw-semibold text-uppercase d-block mb-2">
                {t("home.whyChooseUs.subtitle")}
              </small>
              <h2 className="fw-bold fs-5 fs-lg-3">
                {t("home.whyChooseUs.title")}
              </h2>
            </div>

            <Button
              variant="outline-danger"
              className="px-4 py-2 fw-semibold"
              href="/contact"
            >
              {t("home.whyChooseUs.cta")}
            </Button>
          </div>

          <div className="row g-4">
            {t("home.whyChooseUs.cards", { returnObjects: true }).map(
              (card, index) => (
                <div className="col-12 col-md-6 col-lg-3" key={index}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body p-0 d-flex">
                      {/* Accent column */}
                      <div className="bg-danger-subtle d-flex align-items-center px-3">
                        <span className="fw-bold text-danger fs-5">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                      </div>

                      {/* Content */}
                      <div className="p-4 d-flex flex-column">
                        <h3 className="h6 fw-bold mb-3">{card.title}</h3>

                        <ul className="list-group list-group-flush small text-muted flex-grow-1">
                          {card.points.map((point, i) => (
                            <li key={i} className="list-group-item px-0">
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </Container>
      </section>

      {/* ================= TESTIMONIALS ================= */}
      <section
        className="py-5 position-relative"
        style={{ background: "#ffffff", overflow: "hidden" }}
      >
        <Container>
          <div className="text-center mb-5 position-relative z-index-1">
            <h2 className="fw-bold fs-3">{t("home.testimonialsTitle")}</h2>
            <div
              style={{
                width: "40px",
                height: "3px",
                background: "#dc3545",
                margin: "1rem auto 0",
                borderRadius: "2px",
              }}
            />
          </div>

          <Carousel
            indicators={true}
            controls={true}
            interval={6000}
            pause="hover"
            variant="dark"
            className="pb-5"
          >
            {(Array.isArray(t("home.testimonials", { returnObjects: true }))
              ? t("home.testimonials", { returnObjects: true })
              : []
            ).map((item, index) => (
              <Carousel.Item key={index}>
                <div
                  className="d-flex flex-column align-items-center text-center mx-auto"
                  style={{ maxWidth: "750px", padding: "0 15px" }}
                >
                  {/* Decorative Quote Icon */}
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="rgba(220,53,69,0.15)"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mb-4"
                  >
                    <path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" />
                  </svg>

                  {/* Testimonial Text */}
                  <p
                    className="fst-italic mb-4"
                    style={{
                      fontSize: "1.15rem",
                      lineHeight: "1.8",
                      color: "#495057",
                      fontWeight: "400",
                    }}
                  >
                    "{item.text}"
                  </p>

                  {/* Avatar & Name */}
                  <div className="d-flex flex-column align-items-center mt-3">
                    <div
                      style={{
                        width: "85px",
                        height: "85px",
                        borderRadius: "50%",
                        padding: "4px",
                        background: "#fff",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                        marginBottom: "15px",
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <h5
                      className="fw-bold mb-1"
                      style={{ color: "#1a1a2e", fontSize: "1.1rem" }}
                    >
                      {item.name}
                    </h5>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section>

      {/* ================= ABOUT ================= */}
      <section className="bg-white py-5">
        <Container>
          <div className="row align-items-center g-5 flex-column-reverse flex-lg-row text-center text-lg-start">
            <div className="col-lg-6">
              <small className="text-danger fw-semibold text-uppercase">
                {t("home.about.subtitle")}
              </small>

              <h2 className="fw-bold mt-3 mb-3 fs-5 fs-lg-3">
                {t("home.about.title")}
              </h2>

              <p className="text-muted mb-4">{t("home.about.description")}</p>

              {/* <div className="border-start border-danger ps-3 mb-4">
                <p className="fst-italic text-muted">
                  "{t("home.about.quote.text")}"
                </p>
                <small className="fw-semibold text-uppercase text-muted">
                  — {t("home.about.quote.author")}
                </small>
              </div> */}

              <div className="d-flex gap-3 flex-wrap justify-content-center justify-content-lg-start">
                <Button variant="danger" href="/about">
                  {t("home.about.cta.label1")}
                </Button>
                <Button variant="outline-dark" href="/contact">
                  {t("home.about.cta.label2")}
                </Button>
              </div>
            </div>

            <div className="col-lg-6">
              <img
                src="/why choose us.jpg"
                alt="Professional training session"
                width="600"
                height="400"
                loading="lazy"
                className="img-fluid shadow-sm rounded w-100"
              />
            </div>
          </div>
        </Container>
      </section>

      <Footer t={t} />
    </>
  );
}

export default Home;
